import type React from 'react';

import { Redirect } from '@change-corgi/core-react/router';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export const RedirectUnpublished: React.FC<EmptyProps> = () => {
	const {
		data: {
			petition: { status, slug },
		},
	} = usePetitionDetailsPageData();

	if (status === 'UNPUBLISHED') {
		return <Redirect to={`/p/${slug}/preview`} reason="unpublished" />;
	}

	return null;
};
